import React from "react";
import { ImageList, ImageListProps, ImageListItem, ImageListItemProps, ImageListItemBarProps, ImageListItemBar } from "@mui/material";

// ------------- main image list export -------------
type WcImageListProps = ImageListProps;

export const WcImageList = ({ children, ...props }: WcImageListProps) => <ImageList {...props}>{children}</ImageList>;

export default WcImageList;
// ----------------------------------------------------

// ------------- image list item export -------------

type WcImageListItemProps = ImageListItemProps;

export const WcImageListItem = ({ children, ...props }: WcImageListItemProps) => <ImageListItem {...props}>{children}</ImageListItem>;

// ----------------------------------------------------

// ------------- image list item bar export -------------

type WcWcImageListItemBarProps = ImageListItemBarProps;

export const WcImageListItemBar = ({ children, ...props }: WcWcImageListItemBarProps) => <ImageListItemBar {...props} />;

// ----------------------------------------------------

//export const useWcTableCellClasses = () => tableCellClasses;
